import { Component, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-slider-horizontal',
  templateUrl: './slider-horizontal.component.html',
  styleUrls: ['./slider-horizontal.component.css']
})
export class SliderHorizontalComponent implements OnInit {

  @Input() items: any[] = [];
  @Input() itemTemplate!: TemplateRef<any>;

  constructor() { }

  ngOnInit(): void {
  }

}
